import type {
  AdminCreateEmailOTPInput,
  AdminCreateOTPInput,
  AdminLoginByEmailInput,
  AdminLoginByPhoneInput,
  AdminRefreshTokenInput,
} from '../api'
import { api } from '../api'

const adminLoginByEmail = async (data: AdminLoginByEmailInput) => {
  return await api.v1.adminLoginByEmail(data)
}

const adminLoginByPhone = async (data: AdminLoginByPhoneInput) => {
  return await api.v1.adminLoginByPhone(data)
}

const adminAuthRefresh = async (data: AdminRefreshTokenInput) => {
  return await api.v1.adminAuthRefresh(data)
}

const createAdminEmailOtp = async (data: AdminCreateEmailOTPInput) => {
  return await api.v1.adminCreateEmailOtp({
    ...data,
  })
}
const createAdminPhoneOtp = async (data: AdminCreateOTPInput) => {
  return await api.v1.adminCreatePhoneOtp({
    ...data,
  })
}

export default {
  adminLoginByEmail,
  adminLoginByPhone,
  adminAuthRefresh,
  createAdminEmailOtp,
  createAdminPhoneOtp,
}
